<h5 class="payment-cards-title fgbcl-subheading-title">
  {{ 'payment.cards.title' | translate }}
</h5>

<div class="payment-cards-container">
  <fgbcl-add-new-card
    [regex]="regex"
    [provider]="provider"
    [redirectUrl]="redirectUrl"
    [topUpAddressConfig]="topUpAddressConfig"
    [failureUrl]="failureUrl"
    [showCloseBtn]="showCloseBtn"
    [version]="version"
    class="w-mb-100 add-card-btn"
  ></fgbcl-add-new-card>
  <ng-container
    *ngIf="{ defaultCard: defaultCardToken$ | async, otherCards: nonDefaultCardTokens$ | async } as cardTokens; else loadingRef"
  >
    <ng-container *ngIf="cardTokens.defaultCard || cardTokens.otherCards.length">
      <div class="mobile-cards-carousel">
        <owl-carousel-o [options]="customOptions" class="card-padding">
          <ng-template carouselSlide *ngIf="cardTokens.defaultCard" [width]="224">
            <fgbcl-card-token
              [cardToken]="cardTokens.defaultCard"
              [cardIssuerProvider]="cardIssuerProvider"
              [showExpiry]="showExpiry"
            ></fgbcl-card-token>
          </ng-template>
          <ng-container *ngFor="let card of cardTokens.otherCards">
            <ng-template carouselSlide [width]="224">
              <fgbcl-card-token
                [cardToken]="card"
                [cardIssuerProvider]="cardIssuerProvider"
                [showExpiry]="showExpiry"
              ></fgbcl-card-token>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>

      <div class="desktop-cards-list">
        <owl-carousel-o [options]="customOptions2" class="card-padding">
          <ng-template carouselSlide *ngIf="cardTokens.defaultCard" [width]="224">
            <fgbcl-card-token
              [cardToken]="cardTokens.defaultCard"
              [cardIssuerProvider]="cardIssuerProvider"
              [showExpiry]="showExpiry"
            ></fgbcl-card-token>
          </ng-template>
          <ng-container *ngFor="let token of cardTokens.otherCards">
            <ng-template carouselSlide [width]="224">
              <fgbcl-card-token
                [cardToken]="token"
                [cardIssuerProvider]="cardIssuerProvider"
                [showExpiry]="showExpiry"
              ></fgbcl-card-token>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
